import { render } from "./Add.vue?vue&type=template&id=5a2de5dc"
import script from "./Add.vue?vue&type=script&lang=js"
export * from "./Add.vue?vue&type=script&lang=js"
script.render = render

export default script